function TitleRedundant() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Title attribute text is the same as text or alternative text.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>The title attribute value is used to provide advisory information. It typically appears when the users hovers the mouse over an element. The advisory information presented should not be identical to or very similar to the element text or alternative text.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>In most cases the title attribute can be removed, otherwise modify it to provide advisory, but not redundant information. Note that the title text may or may not be read by a screen reader and is typically inaccessible to sighted keyboard users.</p>
    </blockquote>
  )
}

export default TitleRedundant